/* eslint-disable import/order */
import { MenuIdStatusPageManage } from '@jira/navigation-apps__constants/src/MenuIdStatusPageManage.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { communicationsStatusPageDetailsRoute } from '@jira/router-routes__communications-routes/src/communicationsStatusPageDetailsRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { StatusPageDetailsPageEntryPoint } from './ui/status-page-details/StatusPageDetailsPageEntryPoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const communicationsStatusPageDetailsRouteEntry: Route = createEntry(
	communicationsStatusPageDetailsRoute,
	() => ({
		group: 'communications',
		navigation: {
			menuId: MenuIdStatusPageManage,
		},
		entryPoint: () => {
			return fg('communications_status_page_manage_platform')
				? StatusPageDetailsPageEntryPoint
				: undefined;
		},
		resources: [...getNavigationResources()],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
